import ScenarioShowValue from './ScenarioShowValue'
import React from 'react'
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
  contentListValue: {
    '&::after': {
      content: "",
      display: "table",
      clear: "both",
    },
  },

})

const checkDataInput = val => {
  if (val === null || val === undefined || val === '') {
    return false
  } else {
    return true
  }
}
export const ValueTypeRealEstate = ({
  data,
  dataValueChange1,
}) => {

  const classes = useStyles()
  return (
    <div className={classes.contentListValue}>
      {checkDataInput(data?.total_real_estate_assets) && (
        <ScenarioShowValue
          title={'Total Real Estate Assets'}
          attribute={'total_real_estate_assets'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.cash_and_equivalents) && (
        <ScenarioShowValue
          title={'Cash & Equivalents'}
          attribute={'cash_and_equivalents'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.accounts_receivables) && (
        <ScenarioShowValue
          title={'Accounts Receivables'}
          attribute={'accounts_receivables'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.investment_in_debt_equity_securities) && (
        <ScenarioShowValue
          title={'Investment in Debt and Equity'}
          attribute={'investment_in_debt_equity_securities'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.goodwill) && (
        <ScenarioShowValue
          title={'Goodwill'}
          attribute={'goodwill'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.other_intangibles) && (
        <ScenarioShowValue
          title={'Other Intangibles Total'}
          attribute={'other_intangibles'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.other_assets_total) && (
        <ScenarioShowValue
          title={'Other Assets'}
          attribute={'other_assets_total'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioShowValue
          title={'Share Price'}
          attribute={'close'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioShowValue
          title={'Equity Volatility'}
          attribute={'vol_forecast_annualised'}
          dataValueChange1={dataValueChange1}
        />
      )}
    </div>
  )
}

export const ValueTypeInsurance = ({
                                     data,
                                     dataValueChange1,
}) => {
  const classes = useStyles()

  return (
    <>
      {checkDataInput(data?.insurance_risk) && (
        <ScenarioShowValue
          title={'Insurance Risk'}
          valueScenario={data?.insurance_risk}
          attribute={'insurance_risk'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.market_and_credit_risk) && (
        <ScenarioShowValue
          title={'Credit & Market Risk'}
          valueScenario={data?.market_and_credit_risk}
          attribute={'market_and_credit_risk'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioShowValue
          title={'Equity Price'}
          valueScenario={data?.close}
          attribute={'close'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioShowValue
          title={'Equity Volatility'}
          valueScenario={data?.vol_forecast_annualised}
          attribute={'vol_forecast_annualised'}
          dataValueChange1={dataValueChange1}
        />
      )}
    </>
  )
}

export const ValueTypeBanks = ({
                                 data,
                                 dataValueChange1,
}) => {
  const classes = useStyles()
  return (
    <>
      {checkDataInput(data?.risk_weighted_assets) && (
        <ScenarioShowValue
          title={'Risk Weighted Assets'}
          attribute={'risk_weighted_assets'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioShowValue
          title={'Equity Price'}
          attribute={'close'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioShowValue
          title={'Equity Volatility'}
          attribute={'vol_forecast_annualised'}
          dataValueChange1={dataValueChange1}
        />
      )}
    </>
  )
}

export const ValueTypeNonFinancials = ({
                                         data,
                                         dataValueChange1,
}) => {
  const classes = useStyles()
  return (
    <>
      {checkDataInput(data?.short_term_debt) && (
        <ScenarioShowValue
          title={'Short Term Debt'}
          attribute={'short_term_debt'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.long_term_debt) && (
        <ScenarioShowValue
          title={'Long Term Debt'}
          attribute={'long_term_debt'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioShowValue
          title={'Equity Price'}
          attribute={'close'}
          dataValueChange1={dataValueChange1}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioShowValue
          title={'Equity Volatility'}
          attribute={'vol_forecast_annualised'}
          dataValueChange1={dataValueChange1}
        />
      )}
    </>
  )
}

export const ValueScenario2 = ({
  dataOld,
  dataValueChange2
}) => {

  return (
    <>
      {checkDataInput(dataOld?.asset_value) && (
        <ScenarioShowValue
          title={'Market Value of Assets'}
          attribute={'asset_value'}
          dataValueChange1={dataValueChange2}
        />
      )}
      {checkDataInput(dataOld?.asset_sigma) && (
        <ScenarioShowValue
          title={'Market Volatility of Assets'}
          attribute={'asset_sigma'}
          dataValueChange1={dataValueChange2}
        />
      )}
    </>
  )
}
